<div class="input-container input-type-toggle {{ wrapperCssClass }}">
  <mat-label></mat-label>
  <mat-slide-toggle
      color="primary"
      [formControl]="fControl"
  >
    {{ label }}
  </mat-slide-toggle>
</div>
